module.exports = __webpack_public_path__ + "static/media/dashboard_icon_wh.c5c49d89.svg";